const SIZE_SMALL = 'small'
const SIZE_MEDIUM = 'medium'

export const ICON_SIZES = {
  [SIZE_MEDIUM]: 28,
  [SIZE_SMALL]: 20,
}
